module.exports = __webpack_public_path__ + "static/media/typeb2.de4c1b8e.jpg";